import React from "react";
import { useState, createContext } from "react";

export const FullStackContext = createContext();

export const FullStackProvider = (props) => {
  const [fullStack] = useState([
    {
      id: "21",
      name: "Customer Relations Management",
      description: "Full stack Project based on CRM with NodeJS and React",
      deploy: false,
      deployment: "",
      code: "https://github.com/shelcia/crm-frontend",
    },
    {
      id: "22",
      name: "Rasa NLU",
      description:
        "I was commisioned to build Frontend Interface For NLU applications",
      deploy: false,
      deployment: "",
      code: "https://github.com/shelcia/rasanluinterface",
    },
  ]);
  return (
    <FullStackContext.Provider value={fullStack}>
      {props.children}
    </FullStackContext.Provider>
  );
};
